export default __webpack_public_path__ + "static/bryansk-ae40b3d8cf0d5ba739fd4b4d6910d9d5.webp";